// Material Dashboard 2 PRO React TS Base Styles
import colors from '@theme/base/colors';
import borders from '@theme/base/borders';

// Material Dashboard 2 PRO React Helper Function
import rgba from '@theme/functions/rgba';

const { black, white } = colors;
const { borderWidth, borderRadius } = borders;

// types
// types
type Types = any;

const card: Types = {
  styleOverrides: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      minWidth: 0,
      wordWrap: 'break-word',
      backgroundColor: white.main,
      backgroundClip: 'border-box',
      border: `${borderWidth[0]} solid ${rgba(black.main, 0.125)}`,
      borderRadius: borderRadius.xl,
      boxShadow: '0 20px 27px 0 rgb(0 0 0 / 5%)',
      overflow: 'visible'
    }
  }
};

export default card;
